import {
  applyVisualConflictStatusToGanttTasks,
  detectUnfitTaskDates
} from './utils';

const alreadyProcessedActivities = new Set();

const detectConflictDatesDuration = (activity) => {
  const activityReference = activity;
  const activityId = activityReference.unique_id;
  if (alreadyProcessedActivities.has(activityId)) return;
  alreadyProcessedActivities.add(activityId);
  activity._skipConflictUpdate = true;
  const updatedLeafTasks = detectUnfitTaskDates(activityReference);

  applyVisualConflictStatusToGanttTasks(
    updatedLeafTasks,
    window.ganttVisualization,
    activityReference
  );
  setTimeout(() => {
    alreadyProcessedActivities.delete(activityId);
  }, 0);
};

export { detectConflictDatesDuration };
